import React from 'react';
import {
  Dialog, DialogClose, DialogContent, DialogTitle,
} from '../../../components/base/Dialog/Dialog';

import MobileParkingMeterItem from './MobileParkingMeterItem';

export default function MobileParkingMeterPopup(props) {
  const { handleClose = () => {}, item } = props;
  if (!item) {
    return null;
  }
  return (
    <Dialog
      onClose={handleClose}
      open
      className="parking-meter-popup"
      size="xl"
    >
      <DialogContent>
        <MobileParkingMeterItem item={item} handleClose={handleClose} />
      </DialogContent>
    </Dialog>
  );
}
